import React, {FC} from 'react';

import {ExportContactsCsvJobModel} from '../../../../../../libs/shared/core/src/models/api/jobModel';
import {ContactsCsvExportBannerContainer} from './contactsCsvExportBannerContainer';

/*
 * Props.
 */

interface ContactsCsvExportBannersProps {
  jobs: ReadonlyArray<ExportContactsCsvJobModel>;
}

/*
 * Component.
 */

export const ContactsCsvExportBanners: FC<ContactsCsvExportBannersProps> = (props) => {
  const {jobs} = props;
  return (
    <>
      {jobs.map((job) => (
        <ContactsCsvExportBannerContainer key={job.id} job={job} />
      ))}
    </>
  );
};
